export default __webpack_public_path__ + "static/media/surgifit_logo.5c8dccba.png";